import React, { memo } from 'react';
import classNames from 'classnames';
import styles from './index.module.scss';

interface MentionTokenProps {
  id: string;
  name: string;
}

function MentionToken({ id, name }: MentionTokenProps) {
  return (
    <span className={classNames([styles.mention, 'RoboneoInlineAgent'])} data-mention-id={id}>
      @
      {name}
    </span>
  );
}

export default memo(MentionToken);
